export default {"src":"/_next/static/media/ethereum.31973a45.svg","height":225,"width":225};